import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1313700f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-recent" }
const _hoisted_2 = {
  key: 0,
  class: "group"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "more" }
const _hoisted_6 = { class: "list participation-history" }
const _hoisted_7 = {
  key: 1,
  class: "group"
}
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "more" }
const _hoisted_11 = { class: "list collection-history" }

import { reactive } from 'vue';
import ParticipationHistoryItem from './participation-history-item.vue';
import CollectionHistoryItem from './collection-history-item.vue';
import { UserRequestStore } from '@/stores/user-request';
import { useI18n } from 'vue-i18n';

interface Props {
  role: string | undefined;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    role: null
  },
  setup(__props: any) {


const { t } = useI18n();
const userParticipationRecordStore = new UserRequestStore({ type_eq: 'ParticipationRequest', per_page: 4 });
const userCollectionRequestsStore = new UserRequestStore({ type_eq: 'ParticipationRequest', per_page: 2, show_program_shipments: true, order_by: 'recent_collection_request' });

const participationRecordStore = reactive(userParticipationRecordStore);
const collectionRequestsStore = reactive(userCollectionRequestsStore);
participationRecordStore.fetchData();
collectionRequestsStore.fetchData();

function handleUpdate(type: string) {
  if (type === 'participation') {
    participationRecordStore.fetchData();
  } else {
    collectionRequestsStore.fetchData();
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(participationRecordStore).data.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('Recent participating campaigns')), 1),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_router_link, { to: { name: 'mine.participationHistory' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('more')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(participationRecordStore).data, (item, index) => {
              return (_openBlock(), _createBlock(ParticipationHistoryItem, {
                key: index,
                modelValue: _unref(participationRecordStore).data[index],
                "onUpdate:modelValue": ($event: any) => ((_unref(participationRecordStore).data[index]) = $event),
                onUpdate: _cache[0] || (_cache[0] = ($event: any) => (handleUpdate('participation')))
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(collectionRequestsStore).data.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('Recent collection records')), 1),
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_router_link, { to: { name: 'mine.collectionHistory' } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('more')), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collectionRequestsStore).data, (item, index) => {
              return (_openBlock(), _createBlock(CollectionHistoryItem, {
                key: index,
                modelValue: _unref(collectionRequestsStore).data[index],
                "onUpdate:modelValue": ($event: any) => ((_unref(collectionRequestsStore).data[index]) = $event),
                role: __props.role,
                onUpdate: _cache[1] || (_cache[1] = ($event: any) => (handleUpdate('collection')))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "role"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})